import '@/assets/css/tailwind.css';
import '@/assets/css/main.css';
import '@/assets/style.css';
import 'material-design-icons/iconfont/material-icons.css';
import 'vue-select/dist/vue-select.css';
import 'vue-datetime/dist/vue-datetime.css';
import vSelect from 'vue-select';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueQrcode from '@chenfengyuan/vue-qrcode';

import functions from './plugins/functions';
import server from './plugins/server';
import colors from './plugins/colors';
import icons from './plugins/icons';
import jwtService from './plugins/jwt.service';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import countries from '@/assets/data/countries.json';
import countriestimezones from '@/assets/data/country-timezones-currency.json';
import VueInsProgressBar from 'vue-ins-progress-bar';
import Progress from 'easy-circular-progress';

import components from './components';
import VueSimpleAlert from 'vue-simple-alert';

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/fr';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

Vue.component(VueQrcode.name, VueQrcode);
Vue.component('apexchart', VueApexCharts);
Vue.component('date-picker', DatePicker);

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)

import i18n from './i18n/i18n';

import _ from 'lodash';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Chrome } from 'vue-color';

Vue.component('loading', Loading);
Vue.component('Progress', Progress);
Vue.component('chrome-picker', Chrome);
import Modal from '@burhanahmeed/vue-modal-2';
Vue.use(Modal);
Vue.use(VueSimpleAlert);

import Tabs from 'vue-tabs-component';
Vue.use(Tabs);

Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  position: 'top-center',
  timeout: 20000,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
});

const options = {
  position: 'fixed',
  show: true,
  height: '8px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
};

Vue.use(VueInsProgressBar, options);

import { Datetime } from 'vue-datetime';
Vue.component('datetime-v2', Datetime);

import VueBarcode from '@chenfengyuan/vue-barcode';
Vue.component('vue-barcode', VueBarcode);

components.forEach(c => {
  Vue.component(c.name, c.component);
});
Vue.component('v-select', vSelect);

Vue.prototype.$f = functions;
Vue.prototype.$server = server;
Vue.prototype.$colors = colors;
Vue.prototype.$icons = icons;
Vue.prototype.$jwtService = jwtService;
Vue.prototype.$me = server.me('users');
Vue.prototype.$moment = moment;
Vue.prototype.$momentTimezone = momentTimezone;
Vue.prototype.$countries = countries;
Vue.prototype.$countriestimezones = countriestimezones;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: function(h) {
    return h(App);
  },
}).$mount('#app');
